import { render, staticRenderFns } from "./CompanyDetailsForm.vue?vue&type=template&id=09ddec4a"
import script from "./CompanyDetailsForm.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports